import { apiGet } from '../api'

export const get_interview = query => {
  return apiGet({
    endpoint: `interviews/get_interview?user_id=${query}`
  })
}
